import React from 'react';
import { Clock, CheckCircle2 } from 'lucide-react';

const TodaysWork = ({ work }) => {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col">
            <h3 className="text-sm font-bold text-gray-900 mb-4">Today&apos;s Work</h3>

            <div className="flex-1 overflow-y-auto pr-2 custom-scrollbar">
                {/* In Progress Section */}
                <div className="mb-4">
                    <div className="bg-gray-200 rounded-lg px-4 py-2 flex items-center mb-2">
                        <Clock size={24} className="text-gray-600 mr-2" />
                        <span className="text-sm font-semibold text-gray-700">In Progress ({work?.inProgress?.length || 0})</span>
                    </div>
                    {work?.inProgress?.length > 0 ? (
                        <div className="flex flex-col gap-2">
                            {work?.inProgress?.map((task) => (
                                <div
                                    key={task.id}
                                    className="bg-white border border-gray-200 rounded-lg px-4 py-3 flex items-start shadow-md"
                                >
                                    <Clock size={20} className="text-gray-500 mr-3 mt-0.5 flex-shrink-0" />
                                    <div className="flex flex-col gap-1">
                                        <span className="text-sm text-gray-700 font-medium">{task.name}</span>
                                        {task.workType?.name && (
                                            <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded w-fit">
                                                {task.workType.name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-8 px-4">
                            {/* Icon */}
                            <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center">
                                <svg
                                    className="w-8 h-8 text-amber-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </div>

                            {/* Main Message */}
                            <h4 className="text-gray-900 font-semibold text-base mb-2">
                                No Tasks In Progress
                            </h4>

                            {/* Descriptive Text */}
                            <p className="text-gray-500 text-sm text-center max-w-xs">
                                Tasks currently being worked on will appear here.
                            </p>
                        </div>
                    )}
                </div>

                {/* Completed Section */}
                <div>
                    <div className="bg-[#D1F2EB] rounded-lg px-4 py-2 flex items-center mb-2">
                        <CheckCircle2 size={24} className="text-[#2ECC71] mr-2" />
                        <span className="text-sm font-semibold text-gray-700">Completed ({work?.completed?.length || 0})</span>
                    </div>
                    {work?.completed?.length > 0 ? (
                        <div className="flex flex-col gap-2">
                            {work?.completed?.map((task) => (
                                <div
                                    key={task.id}
                                    className="bg-[#F0FDF4] border border-[#D1F2EB] rounded-lg px-4 py-3 flex items-start shadow-md"
                                >
                                    <CheckCircle2 size={20} className="text-[#2ECC71] mr-3 mt-0.5 flex-shrink-0" />
                                    <div className="flex flex-col gap-1">
                                        <span className="text-sm text-gray-700 font-medium">{task.name}</span>
                                        {task.workType?.name && (
                                            <span className="text-xs text-green-700 bg-green-100 px-2 py-0.5 rounded w-fit">
                                                {task.workType.name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-8 px-4">
                            {/* Icon */}
                            <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center">
                                <svg
                                    className="w-8 h-8 text-blue-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                    />
                                </svg>
                            </div>

                            {/* Main Message */}
                            <h4 className="text-gray-900 font-semibold text-base mb-2">
                                No Completed Tasks Yet
                            </h4>

                            {/* Descriptive Text */}
                            <p className="text-gray-500 text-sm text-center max-w-xs">
                                Completed tasks for today will be shown here.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TodaysWork;
